import React from "react";

const Product = () => {
  const stats = [
    {
      title: "Skilled Professionals",
      value: "879",
      bgColor: "bg-white shadow-md border ", // Custom background and border
    },
    {
      title: "Daily Learners",
      value: "1056",
      bgColor: "bg-white shadow-md border", // Custom background color
    },
    {
      title: "Global Market Impact",
      value: "10k",
      bgColor: "bg-white shadow-md border",
    },
    {
      title: "Success Rate",
      value: "98%",
      bgColor: "bg-white shadow-md border",
    },
  ];
  return (
    <>
      <div className="bg-white sm:pb-16 py-6">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:max-w-none">
            <div className="lg:text-center ">
              <span className="bg-white lg:px-3 sm:text-2xl text-2xl lg:text-4xl leading-normal font-bold text-gray-900">
                Helping Business Globally
              </span>
              <p className=" text-gray-700 sm:text-lg text-base text-justify   lg:text-center">
                Transform your digital presence and reach customers worldwide
                through expert web design.
              </p>
            </div>

            <dl className="mt-6 grid grid-cols-1 gap-4 overflow-hidden text-center sm:grid-cols-2 lg:grid-cols-4">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className={`relative flex flex-col border-gray-300 p-8 ${stat.bgColor} group`}
                >
                  {/* Hover border top line */}
                  <div className="absolute top-0 left-0 w-full h-1 scale-x-0 transform bg-amber-700 transition-transform duration-300 group-hover:scale-x-100"></div>

                  <dt className="text-sm font-semibold leading-6 text-gray-600">
                    {stat.title}
                  </dt>
                  <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
